<template>
  <div>

    <el-table v-loading="loadTable" :data="records" stripe height="450">
      <el-table-column
          type="selection"
          width="55">
      </el-table-column>
      <el-table-column fixed label="ID" prop="id">
        <template slot-scope="scope">
                    <span>
                       {{ scope.row.id }}
                    </span>
        </template>
      </el-table-column>
      <el-table-column label="手机" prop="phone">
        <template slot-scope="scope">
                    <span>
                       {{ scope.row.phone?scope.row.phone:'用户未注册' }}
                    </span>
        </template>
      </el-table-column>
      <el-table-column label="最近访问" prop="lastTime">
        <template slot-scope="scope">
                    <span>
                       {{ scope.row.lastTime }}
                    </span>
        </template>
      </el-table-column>
      <el-table-column label="昵称" prop="nickName">
        <template slot-scope="scope">
                    <span>
                       {{ scope.row.nickName?scope.row.nickName:'用户未注册' }}
                    </span>
        </template>
      </el-table-column>
      <el-table-column label="头像" prop="headImage">
        <template slot-scope="scope">
          <div class="demo-image__preview">
            <el-image
                style="width: 50px; height: 50px"
                :src="scope.row.headImage[0]"
                :preview-src-list="scope.row.headImage">
            </el-image>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <page :current="current" :size="size" :total="total"/>






  </div>
</template>

<script>


import Page from "@/components/Page";
import adminGetNewsHistory from "@/api/user/admin-controler/adminGetNewsHistory";

export default {
  name: "NewsHistory",
  components: {Page},
  data() {
    return {
      current:1,
      size:10,
      total: 0,

      fileBaseUrl: process.env.VUE_APP_FILE_BASE_URL,

      params: {
        newsId: localStorage.getItem("newsHistoryId"),
      },

      loadTable: false,
      records: [],
    }
  },

  methods: {
    getNewsHistory(){
      console.log(this.params)
      adminGetNewsHistory(this.current, this.size, this.params).then(res=>{
        let data = res.data.data
        console.log(data)
        for (let i = 0; i < data.length; i++) {
          if(data[i].headImage) {
            data[i].headImage=[this.fileBaseUrl+data[i].headImage]
          } else {
            data[i].headImage=['https://thirdwx.qlogo.cn/mmopen/vi_32/POgEwh4mIHO4nibH0KlMECNjjGxQUq24ZEaGT4poC6icRiccVGKSyXwibcPq4BWmiaIGuG1icwxaQX6grC9VemZoJ8rg/132']
          }
        }
        this.records = data
        this.total = res.data.total
      })
    },
    fetchData(){
      this.getNewsHistory()
    },
  },

  mounted() {
    this.fetchData()
  },

}
</script>

<style lang="scss" scoped>


</style>
